"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../actions/types");
var initialState = {
    statistics: {
        userCount: 0,
        linkCount: 0,
        clickCount: 0,
        fileCount: 0,
        agencyCount: 0,
    },
};
var home = function (state, action) {
    if (state === void 0) { state = initialState; }
    var nextState = {};
    switch (action.type) {
        case types_1.SET_LINKS_TO_ROTATE:
            nextState = {
                linksToRotate: action.payload,
            };
            break;
        case types_1.LOAD_STATS:
            nextState = {
                statistics: action.payload,
            };
            break;
        default:
            return state;
    }
    return __assign(__assign({}, state), nextState);
};
exports.default = home;
